export default __webpack_public_path__ + "static/map-4edac4ec1529c496abb2b4e91463a7e5.png";